import {
  OUR_MISSION,
  OUR_TEAM,
  ARTIST_SEARCH_ESTIMATES,
  FAQ,
  KNOWLEDGECENTER,
  LABELHOME,
  PARTNERS,
  PRESS,
  GLOSSARY,
  PUBLISHING,
  DEAL_COMPARISON,
  FUNDING_NETWORK,
} from "../../routes/constants";

export const DRAWER_NAVIGATION = [
  {
    title: "Funding",
    link: FUNDING_NETWORK,
    options: [
      { title: "Artists", to: ARTIST_SEARCH_ESTIMATES },
      { title: "Labels", to: LABELHOME },
      { title: "Distributors", to: PARTNERS },
      { title: "Songwriters", to: PUBLISHING },
      { title: "Producers", to: PUBLISHING },
      { title: "Compare Offers", to: DEAL_COMPARISON },
    ],
  },
  {
    title: "About Us",
    link: OUR_MISSION,
    options: [
      { title: "Our Mission", to: OUR_MISSION },
      { title: "Our Advisors", to: OUR_TEAM },
      { title: "Partners", to: PARTNERS },
      { title: "News", to: PRESS },
    ],
  },
  {
    title: "Resources",
    link: KNOWLEDGECENTER,
    options: [
      { title: "Knowledge Center", to: KNOWLEDGECENTER },
      { title: "FAQs", to: FAQ },
      { title: "Glossary", to: GLOSSARY},
    ],
  },
];
